import type { DlpTheme } from '@ccpgames/eve-web-core'

// Mirror the library type; keep a runtime-safe resolver without a separate list.
export type CmsDlpTheme = DlpTheme

export const DEFAULT_DLP_THEME: CmsDlpTheme = 'EVE Blue'

export function resolveDlpTheme(theme?: string | null): CmsDlpTheme {
  if (!theme) return DEFAULT_DLP_THEME
  return theme as CmsDlpTheme
}

export function toLibraryDlpTheme(theme: CmsDlpTheme): DlpTheme {
  return theme
}
